import React, { memo, useState } from "react";
import {
  Button,
  Card,
  Form,
  Spinner
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import "./index.css";

import { Creators as LoadersActions } from "../../store/ducks/loaders";
import { Creators as NotificationsActions } from "../../store/ducks/notifications";

import { isScopes } from "../../services/Auth";
import { getDefaultOptionsChip } from "../../utils/Report";
import { mergeObject } from "../../utils/Object";

import Item from "./Item";
import Option from "../Option";

import ChipService from "../../services/Chip";

const Chip = ({
  props: { currentUser, chipsSearchSelected, periodDateEnd, periodDateStart },
  funcs: { addNotice, enableLoader, disableLoader }
}) => {
  const { t } = useTranslation();
  const chipService = new ChipService();
  const [running, setRunning] = useState(false);
  const [selectedReport, setSelectedReport] = useState({
    selected: false,
    options: false,
    values: false
  });

  const buttonDisabled = () => {
    if(chipsSearchSelected.length > 0) {
      return false;
    }
    return true;
  };

  const changeSelectedReport = (item) => {
    setSelectedReport({
      selected: false,
      options: false,
      values: false
    });
    if(item !== false) {
      setTimeout(() => {
        const options = getDefaultOptionsChip();
        item.options = mergeObject(options, item.options);
        setSelectedReport(item);
      }, 100);
    }
  };

  const getDateSelected = () => {
    return {
      endDate: periodDateEnd,
      startDate: periodDateStart
    };
  };

  const getChipsSearchSelected = () => {
    const chips = [];
    chipsSearchSelected.map(item => {
      return chips.push(item.id);
    });
    return chips;
  };

  const getReport = async (e) => {
    if(!running) {
      setRunning(true);
      enableLoader();
      const { endDate, startDate } = getDateSelected();

      let endAt = undefined;
      if(selectedReport.options.dateEnd) {
        endAt = endDate;
      }

      let startAt = undefined;
      if(selectedReport.options.dateStart) {
        startAt = startDate;
      }

      const response = await chipService.report({ endAt: endAt, id: selectedReport.values.id, chips: getChipsSearchSelected(), startAt: startAt, token: currentUser.token });
      if(response.success) {
        addNotice({
          title: selectedReport.values.title,
          content: t("Success.Report.Request")
        });
      }
      else {
        addNotice({
          title: selectedReport.values.title,
          content: t("Error.Report.Request")
        });
      }
      changeSelectedReport(false);
      setTimeout(() => {
        disableLoader();
        setRunning(false);
      }, 100);
    }
  };

  const reports = [
    {
      id: "reports-chip-history",
      title: t("Title.Chip"),
      icon: <i className="fas fa-sim-card" />,
      onClick: () => {
        const id = "reports-chip-history";
        if(selectedReport.selected === id) {
          return setSelectedReport(false);
        }
        changeSelectedReport({
          selected: id,
          options: {
            filterMultiple: true
          },
          values: {
            id: "chip-history",
            title: t("Title.Chip")
          }
        });
      },
      selected: () => selectedReport.selected === "reports-chip-history",
      scoped: () => isScopes({ currentUser, scopes: ["is:master", "reports:chips:history"], every: false })
    }
  ];

  return (
    <div className="chip-reports">
      <Card>
        <Card.Header>{t("Title.Reports")}</Card.Header>
        <Card.Body>
          <div className="chip-reports-all">
            {
              <ul className="chip-reports-lists">
                {
                  reports.map(report => {
                    return report.scoped() ? (
                      <Item key={report.id} {...report} onClick={report.onClick} />
                    ) : null;
                  })
                }
              </ul>
            }
          </div>
        </Card.Body>
      </Card>
      <div className="chip-reports-options">
        {
          selectedReport.selected ? (
            <>
              <Option {...selectedReport} />
              <Form.Group className="default-form-button">
                <Button
                  variant="dark"
                  type="button"
                  disabled={buttonDisabled()}
                  onClick={getReport}
                >
                  {running ? <Spinner animation="border" size="sm" /> : t("Button.Generate")}
                </Button>
              </Form.Group>
            </>
          ) : (
            <h3 className="chip-reports-not-selected">{t("Title.Reports.NotSelected")}</h3>
          )
        }
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  props: {
    currentUser: state.users.currentUser,
    chipsSearchSelected: state.chips.chipsSearchSelected,
    periodDateEnd: state.period.periodDateEnd,
    periodDateStart: state.period.periodDateStart
  }
});

const mapDispatchToProps = dispatch => ({
  funcs: bindActionCreators(Object.assign({}, LoadersActions, NotificationsActions), dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(memo(Chip));
